import React, { useEffect, useRef, useState } from 'react';

interface ArrowLayerProps {
  children: React.ReactNode;
}

const ArrowLayer: React.FC<ArrowLayerProps> = ({
  children
}) => {
  const svgRef = useRef<SVGSVGElement>(null);
  const [dimensions, setDimensions] = useState({ width: 3000, height: 2000 });

  useEffect(() => {
    const updateDimensions = () => {
      if (svgRef.current && svgRef.current.parentElement) {
        const parent = svgRef.current.parentElement;
        const scrollWidth = parent.scrollWidth;
        const scrollHeight = parent.scrollHeight;

        setDimensions({
          width: Math.max(3000, scrollWidth),
          height: Math.max(2000, scrollHeight)
        });
      }
    };

    updateDimensions();
    window.addEventListener('resize', updateDimensions);

    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  return (
    <svg
      ref={svgRef}
      className="arrow-layer"
      width={dimensions.width}
      height={dimensions.height}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        pointerEvents: 'none',
        overflow: 'visible',
        zIndex: 1
      }}
    >
      {children}
    </svg>
  );
};

export default ArrowLayer;